import script from "./Inicio.vue?vue&type=script&lang=ts&setup=true"
export * from "./Inicio.vue?vue&type=script&lang=ts&setup=true"

import "./Inicio.vue?vue&type=style&index=0&id=fbe40578&lang=css"

const __exports__ = script;

export default __exports__